import {
  Avatar, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton,
  Input, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper, Select, Snackbar, Tooltip, Typography, createMuiTheme,
  CardContent,CardHeader
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { green, red } from '@material-ui/core/colors';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import RefreshIcon from '@material-ui/icons/Refresh';
import RoomIcon from '@material-ui/icons/Room';
import SearchIcon from '@material-ui/icons/Search';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import WorkIcon from '@material-ui/icons/Work';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector  } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { openBlob, sc, getUser } from 'src/utils/Common';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { setTask } from '../../store/actions/taskActions';
import FgsArama from './FgsCall';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import AlarmIcon from '@material-ui/icons/Alarm';
import CancelIcon from '@material-ui/icons/Cancel';
import ThumbUpDownIcon from '@material-ui/icons/ThumbDown';
import { filterActions } from 'src/store/slices/filterSlice';

let MesafeSonuc = 0;


const useStyles = makeStyles((theme) => ({
  root: {},
  avatarAtanan: {
      backgroundColor: red[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    avatar1Atanan: {
      backgroundColor: green[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px',
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonAtanan: {
    padding: 10,
  },
  dividerAtanan: {
    backgroundColor: '#1D3343'
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  urgentButton: {
    marginLeft: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    color: '#b2102f'
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Notifications({
  className, readonly, tasks, AtananIsler, handleRefresh, loading, setTask
}) {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const filter = useSelector((state) => state.filter?.searchedB);
  const dispatch = useDispatch();
  const [stateDurum, setStateDurum] = useState('');
  const [ReceiptNo, setReceiptNo] = useState('');
  const [open, setOpen] = React.useState(false);
  const [confirmJob, setconfirmJob] = React.useState();
  const [confirmnewStatus, setconfirmnewStatus] = React.useState();
  const [Enlem, setEnlem] = useState('');
  const [Boylam, setBoylam] = useState('');
  const locale = localStorage.getItem('i18nextLng');
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: t('success_message') });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [loadingIOT, setLoadingIOT] = useState(false);
  const today = new Date();
  const [StartDate, setStartDate] = useState(sessionStorage.getItem('StartDate') ? sessionStorage.getItem('StartDate') : new Date(today));
  const [EndDate, setEndDate] = useState(sessionStorage.getItem('EndDate') ? sessionStorage.getItem('EndDate') : new Date(today));

  const [openChooseDate, setopenChooseDate] = useState(false);
  const [CustomerAppointment, setCustomerAppointment] = useState(false);
  const [uyariAlert, setuyariAlert] = useState(false);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [NewAppointment, setNewAppointment] = useState(null);
  const [data, setData] = useState({});
  const [AppointmentDateEvent, setAppointmentDateEvent] = useState([]);
  const [Uyari1, setUyari1] = React.useState('');
  const [confirmRejectTitle, setConfirmRejectTitle] = useState('');
  const [confirmRejectDescription, setConfirmRejectDescription] = useState('');
  const [rejectJob, setRejectJob] = React.useState();
  const [rejectOpen, setRejectOpen] = React.useState(false);
  const [sortedData, setSortedData] = useState([]);
  const StartDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', Deger);
  };
  const [selectedReceiptNo,setSelectedReceiptNo]=useState();

  const EndDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', Deger);
  };

  const handleRefreshDate = (e) => {
    setopenChooseDate(false);
    handleRefresh();
  };

  const handleFgsAramaOpen = (event, AtananIsFisNo) => {
    setOpenFgsArama(true);
    setReceiptNo(AtananIsFisNo.toString());
  };
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  };
  const durumMap = new Map([
    [20, t('Başvuru')],
    [21, t('Teknisyende')],
    [22, t('Ustlendi')],
    [33, t('Baslandi')],
    [42, t('Yola_cikildi')]
  ]);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
    setuyariAlert(false);
  };
  const handleChange = (event) => {
    setStateDurum(event.target.value);
  };
  const Kirmizi = {
    color: '#b2102f'
  };
  const Sari = {
    color: '#ffc107'
  };
  const Yesil = {
    color: '#357a38'
  };
  const Mavi = {
    color: '#007FFF'
  };
  const getRandevuColor = (Bas, Bit) => {
    const today = Date.now();
    const bitis = Date.parse(Bit);
    const saat = 1000 * 60 * 60;
    if (bitis > today + saat) {
      return Yesil;
    }
    if (bitis > today + saat / 2) {
      return Sari;
    }

    return Kirmizi;
  };
  const getAvatar = (AtananIs) => {
    const Bas = AtananIs.AppointmentBegin?.substring(12, 2);
    const Bit = AtananIs.AppointmentEnd;
    if ([21, 22, 33, 42].indexOf(parseInt(AtananIs.StatusCode)) === -1) {
      let Kontrol = '';
      const KontrolText = '';
      const KontrolText1 = '';
      if (AtananIs.AppointmentCloseDownControl === 1) {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatar1Atanan}>
            <DoneIcon />
          </Avatar>
        );
      } else {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatarAtanan}>
            <ClearIcon />
          </Avatar>
        );
      }
      return (
        <Typography
          component="span"
          variant="h6"
          style={Sari}
        >
          {Kontrol}
          <br />
          {KontrolText}
          <br />
          {KontrolText1}
        </Typography>
      );
    }

    return (
      <Typography
        component="span"
        variant="h6"
        style={getRandevuColor(Bas, Bit)}
      >
        <div>
          {AtananIs.AppointmentBegin?.substring(11, 16)}
          <br />
          {AtananIs.AppointmentEnd?.substring(11, 16)}
        </div>
      </Typography>
    );
  };

  const getIOT = (AtananIs) => {
    if (parseInt(AtananIs.Barcode) === 0) {
      return <div />;
    }
    return (
      <div>
        {loadingIOT ? <CircularProgress style={Mavi} status="loading" /> : <SettingsInputAntennaIcon style={Mavi} onClick={(event) => handleIOTClickOpen(AtananIs)} />}
        <br />
        <br />
      </div>
    );
  };

  //   if (parseInt(AtananIs.ReceiptNo) === 0) {
  //     return <div />;
  //   }
  //   if (AtananIs.StatusCode === 21) {
  //     return <ThumbUpIcon style={Kirmizi} onClick={(event) => handleClickOpen(AtananIs, 22)} />;
  //   } if (AtananIs.StatusCode === 22) {
  //     return <EmojiTransportationIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 42)} />;
  //   } if (AtananIs.StatusCode === 42) {
  //     return (
  //       <div>
  //         <ThumbUpIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 22)} />
  //         <br />
  //         <br />
  //         <PlayCircleFilledWhiteIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />
  //       </div>
  //     );
  //   }
  // };
  const handleClickReject = (jobId) => {
    axios.post(`/SetWorkOrderReject/${jobId}`)
      .then((response) => {
        const ResponseData = response.data;
        if (ResponseData.ErrorCode === '0') {
          setUyariTip('success');
          setSortedData(AtananIsler.map((item) => (item.ReceiptNo === jobId
            ? {
              ...item,
              StatusCode: ResponseData.StatusId,
              Durum: ResponseData.StatusDesc,
              DURUM_KODU: ResponseData.StatusId,
            }
            : item)));
          handleRefresh();
        } else {
          setUyariTip('error');
          setresponseMessage({ ErrorCode: ResponseData.ErrorCode, ErrorDescription: ResponseData.ErrorDescription });
        }
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      })
      .catch((error) => {
        let ErrorData = '';
        ErrorData = t('offline_messsage');
        setUyariTip('error');
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      });
  };
  const handleClickRejectOpen = (jobId) => {
    setConfirmRejectTitle(`${jobId}`);
    setConfirmRejectDescription(t('reject_message').replace('@Recipient', jobId));
    setRejectJob(jobId);
    setRejectOpen(true);
  };
  const setAppointmentData = value => {
    setNewAppointment(value);
  };

  const handleIOTClick = (AtananIs) => {
    setLoadingIOT(true);
    const Barkod = `${AtananIs.ModelCode + AtananIs.UYIL.toString().substring(2, 4).toString() + AtananIs.SERINO.toString().padStart(6, '0') + AtananIs.UDONEM.toString().padStart(2, '0')}01`;
    const configIOT = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get(`/FileImportExport/ArtemisIOT/${Barkod}`, configIOT)
      .then((response) => {
        if (response.data.type === 'text/plain') {
          setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
          setUyariTip('error');
          setUyari(true);
        } else {
          openBlob(response.data, Barkod);
        }
        setLoadingIOT(false);
      }).catch((error) => {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
        setUyariTip('error');
        setUyari(true);
        setLoadingIOT(false);
      });
  };

  const handleIOTClickOpen = (AtananIs) => {
    // var Uyari = AtananIs.FisNo + " fiş numaralı müşterimizin " + AtananIs.KUL_MODEL_KODU + ' ' + AtananIs.MODEL + ' Ürününe uzaktan bağlanılıp sağlık verilerine ulaşılacaktır. Devam etmek istediğinizdne eminmisiniz?';
    const Uyari = t('IOT_confirm').replace('@FisNo', AtananIs.ReceiptNo).replace('@KulModelKodu', AtananIs.ModelCode).replace('@Model', AtananIs.Model);
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleIOTClick(AtananIs)
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };

  const ToaControl = (AtananIs) => {
    
    var data = AtananIs;

    if (!data) {
        return false; 
    }
    
    const hasValidAddresses = Array.isArray(data.ConsumerAddress) 
                              && data.ConsumerAddress.length > 0;
    const hasValidIssueId = data.IssueReasonId !== null 
                            && data.IssueReasonId !== undefined 
                            && data.IssueReasonId !== 0;
    const hasValidConsumerId = data.CustomerNo !== null 
                                && data.CustomerNo !== undefined 
                                && data.CustomerNo !== 0;
    const hasValidConsumerAddressId = data.Address !== null 
                                      && data.Address !== undefined 
                                      && data.Address !== 0 

    return hasValidIssueId && hasValidConsumerId && hasValidAddresses && hasValidConsumerAddressId;
  }

  const handleToaAssignment = (AtananIs) => {
    if (ToaControl(AtananIs)){
      try {
        axios.get(`/GetTokenAndGuid/${AtananIs.ReceiptNo}`)
          .then((response) => {
            const ResponseData = response.data[0];
            var workOrderGuid = ResponseData.workGuid
            var sessionToken = ResponseData.SessionToken
            window.open(`https://contacttest.beko.com/GlobalScheduling/CallCenter/Index?culture=en-UK&WorkGuid=${workOrderGuid}&App=1&SessionToken=${sessionToken}&CountryId=17`, '_blank');
          }).catch((error) => {
          });
      } catch (error) {
          console.error('Error fetching data:', error);
      }
    }else{
      setUyariTip('warning');
      setOpen(true);
      setUyari1(t('lblToaControlMsg'));
    }
  }

  const handleClickSchedule = (AtananIs) => {
    setSelectedReceiptNo(AtananIs.ReceiptNo);
    setuyariAlert(false);
    if (SessionUser.TenantId === 16) {
      handleToaAssignment(AtananIs);
    } else {
      setCustomerAppointment(true);
    }
  };

  const handleClickOpen = (job, newStatus) => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    function error(err) {
      const Uyari = '';
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);
      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        // setConfirmDescription(`${Uyari} ${newStatusDesc} duruma almak istiyor musunuz?`);
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }
    function success(position) {
      const X1 = job.ENLEM;
      const X2 = job.BOYLAM;
      let Uyari = '';
      let Y1 = '';
      let Y2 = '';
      Y1 = position.coords.latitude;
      Y2 = position.coords.longitude;
      setEnlem(Y1);
      setBoylam(Y2);
      const MesafeSonucAtanan = getDistanceFromLatLonInKm(X1, X2, Y1, Y2).toFixed(1);
      if (isNaN(MesafeSonucAtanan)) {
        MesafeSonuc = 0;
      } else {
        MesafeSonuc = MesafeSonucAtanan;
      }

      if (newStatus === 33 && parseInt(job.ReceiptNo) > 0) {
        if (MesafeSonucAtanan > 100) {
          // Uyari = "Müşteri evinden " + Math.floor(MesafeSonucAtanan) + " metre uzakta işi başlatmaya çalışıyorsunuz!!! İşi başlatmak istediğinize emin misiniz? Müşteri Enlem,Boylam:" + X1 + "," + X2 + " TeknisyenEnlem,Boylam: " + Y1 + ", " + Y2 + " ";
          Uyari = t('mesafe_uyari').replace('@MesafeSonucAtanan', Math.floor(MesafeSonucAtanan)).replace('@X1', X1).replace('@X2', X2)
            .replace('@Y1', Y1)
            .replace('@Y2', Y2);
        }
      }
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);

      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d * 1000;
  }
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  const SessionUser = getUser();
  const updateAppointmentDate = (ReceiptNoParam) => {
    var TimeZone = SessionUser.WriteUTCHour;
    var ResponseDate = new Date(NewAppointment);
    ResponseDate.setHours(ResponseDate.getHours() + parseInt(TimeZone));
    var ResponseDate = moment(ResponseDate).format('YYYY-MM-DDTHH:mm');

    var ResponseDateParam = new Date(NewAppointment);

    axios.post(`/SetUpdateAppointmentDate/${moment(ResponseDate).format('YYYY-MM-DD HH:mm')}/${ReceiptNoParam}`)
      .then((response) => {
        setuyariAlert(true);
        if (response.data[0].ErrorCode !== '0') {
          setLoadingControl(false);
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
        }
        else {
          let job = loadBaslandiJob();
          job = {
            ...job,
            AppointmentDate: moment(ResponseDateParam).format('YYYY-MM-DDTHH:mm'),
          };
          setTask(job)
          saveBaslandiJob(job);
          setData(job);
          handleCloseCustomerAppointment();
          setUyariTip('success');
          setUyariAciklama(t('success_message'));
          handleRefresh();
        }


      })
      .catch((error) => {
        setLoadingControl(false);
        setUyariTip('error');
        setUyariAciklama(t('Error') + error.message);
        setUyari(true);
      });
  };

  const handleCloseCustomerAppointment = () => {
    setCustomerAppointment(false);
  };
  const GetAppointmentDate = () => {
    axios
      .get(`/GetSchedulingEmployee/${SessionUser.ServiceShopId}`)
      .then((response) => {
        if (response.data.length > 0) {
          const TechnicianData = response.data.filter((d) => parseInt(d.Id) === parseInt(SessionUser.TechnicianId));
          const AppointmentH = [];
          TechnicianData[0].Appointment.forEach((item) => {
            const App1 = new Date(item.start);
            const App2 = new Date(item.end);

            AppointmentH.push({
              title: item.title,
              start: App1,
              end: App2,
            });
          });


          if (AppointmentH.length > 0) {
            setAppointmentDateEvent(AppointmentH);
          }
        }
      })
      .catch((error) => { });
  };
  useEffect(() => {
    GetAppointmentDate();
    // eslint-disable-next-line
  }, []);

  const [filteredIsler, setFilteredIsler] = useState(AtananIsler);
  const handleClick = (event, AtananIs) => {
    window.open(`${process.env.REACT_APP_MAP_URL + AtananIs.Latitude},${AtananIs.Longitude}`);
    event.persist();
  };

  const handleOpenDate = () => {
    setopenChooseDate(true);
    setConfirmTitle(t('lblTarihSecimi'));
  };

  useEffect(() => {
    filter === ''
      ? setFilteredIsler(AtananIsler)
      : setFilteredIsler(AtananIsler.filter((item) => sc(item.CustomerFullName, filter) || sc(item.BASVURU_NOTU, filter) || sc(item.ReceiptNo, filter)
        || sc(item.BasvuruNedeni, filter) || sc(item.Mahalle, filter) || sc(item.Telefon, filter) || sc(item.Randevu, filter)));
  }, [filter, AtananIsler]);

  useEffect(() => {
    stateDurum === '' ? setFilteredIsler(AtananIsler)
      : setFilteredIsler(AtananIsler.filter((item) => sc(item.StatusCode, stateDurum)));

    if (stateDurum === '200') { // Kapalı State ise Onaylanan ve teslim edilen state'leri ekle
      setFilteredIsler(AtananIsler.filter((item) => [stateDurum, 4].includes(item.StatusCode)));
    }
  }, [stateDurum, AtananIsler]);


  useEffect(() => {
    if (openFgsArama) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [openFgsArama]);

  const handleFilterChange = (e) => {
    dispatch(filterActions.setSearchedB(e.target.value)); 
  };


  return (
    <div>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        style={{ paddingTop: 90 }}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} message={uyariAciklama} variant={uyariTip} />
      </Snackbar>
      <Paper component="form" className={classes.pageStyleAtanan}>
        <Select
          native
          value={stateDurum}
          disableUnderline
          className={classes.inputAtanan}
          onChange={handleChange}
          label="Durum"
        >
          <option aria-label="None" value="">{t('ddl_Tumu')}</option>
          <option value="21">{t('ddl_Teknisyende')}</option>
          <option value="22">{t('ddl_Ustlendi')}</option>
          <option value="33">{t('ddl_Baslandi')}</option>
          <option value="42">{t('Yola_cikildi')}</option>
          <option value="200">{t('ddl_Kapali')}</option>
        </Select>
        <IconButton
          color="primary"
          onClick={handleRefresh}
          className={classes.iconButtonAtanan}
          aria-label="directions"
        >
          <RefreshIcon />
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => {
            removeBaslandiJob();
          }}
          className={classes.iconButtonAtanan}
          aria-label="directions"
        >
          <SettingsBackupRestoreIcon />
        </IconButton>
      </Paper>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('lblBookingRequired')} style={{textAlign:'left'}} />
        <Divider />
        <Paper
          className={classes.searchAtanan}
          elevation={1}
        >
          <SearchIcon
            className={classes.searchIconAtanan}
          />
          <Input
            className={classes.searchInputAtanan}
            disableUnderline
            value={filter}
            onChange={handleFilterChange}
            placeholder={t('search')}
          />

        </Paper>
        {
          loading || loading2 ? <CircularProgress status="loading" />
            : (
              AtananIsler?.length !== 0 ?
                <List>
                  {filteredIsler.sort((a, b) => a.SIRA - b.SIRA).map((AtananIs) => (
                    <div key={AtananIs.ReceiptNo}>
                      <ListItem>
                        <ListItemAvatar>
                          <div>
                            {parseInt(AtananIs.PAKET) === 1 && <AccountTreeIcon color="primary" />}
                            {/* {getIOT(AtananIs)} */}
                            {getAvatar(AtananIs)}
                            <br />

                            {/* {getDurum(AtananIs)} */}
                            {
                              <ScheduleIcon color="secondary" onClick={() => handleClickSchedule(AtananIs)} />
                            }
                            <br />
                            <ThumbUpDownIcon style={Kirmizi} onClick={(event) => handleClickRejectOpen(AtananIs.ReceiptNo)} />
                          </div>
                        </ListItemAvatar>
                        <ListItemText>
                          <Grid container direction="row-reverse"
                            justifyContent="flex-start"
                            alignItems="center">
                            <Grid item>
                              {AtananIs.UrgentCustomer === 1 &&
                                (<Tooltip title={t('lblUrgentCustomer')}>
                                  <PriorityHighIcon className={classes.urgentButton} />
                                </Tooltip>)}
                            </Grid>
                          </Grid>
                          <Typography
                            variant="body1"
                            component={RouterLink}
                            to={AtananIs.ReceiptNo > 0 ? `/WorkOrder/${AtananIs.ReceiptNo}/summary` : '#'}
                          >

                            {/* <span className={classes.valueAtanan}>{AtananIs.ReceiptNo}</span> */}
                            {' '}
                            <span className={classes.typeAtanan}>
                              <b>{AtananIs.AppointmentDate?.substring(0, 10)}</b>
                              <br />
                              {AtananIs.CustomerFullName}
                              {AtananIs.ReceiptNo > 0 && `(${AtananIs.ReceiptNo})`}
                              <br />
                              {AtananIs.CustomerType}
                              <br />
                              {AtananIs.IssueReason}
                              <br />
                              {AtananIs.Neighborhood}
                              -
                              {AtananIs.Address}
                            </span>
                            <br />
                            {AtananIs.CallCenterNote}
                            <br />

                          </Typography>
                          <div className={classes.fieldsAtanan}>
                            <Grid container spacing={1}>
                              <Grid item xs={2}>
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <PhoneInTalkIcon color="secondary" onClick={(event) => handleFgsAramaOpen(event, AtananIs.ReceiptNo)} />
                                  : AtananIs.StatusCode === 22 && <FastfoodIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />}
                              </Grid>

                              <Grid item xs={8} align="center">
                                <Typography variant="h6">{AtananIs.Status}</Typography>
                              </Grid>
                              <Grid item xs={2} align="right">
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <RoomIcon color="secondary" onClick={(event) => handleClick(event, AtananIs)} />
                                  : AtananIs.StatusCode === 33 && <WorkIcon style={Kirmizi} onClick={(event) => handleClickOpen(AtananIs, 4)} />}
                              </Grid>
                            </Grid>
                          </div>
                        </ListItemText>
                        <ListItemSecondaryAction>
                          {parseInt(AtananIs.ReceiptNo) > 0
                            && (
                              <Tooltip title={t('lblDetaylariGoster')}>
                                <IconButton
                                  color="primary"
                                  component={RouterLink}
                                  to={`/WorkOrder/${AtananIs.ReceiptNo}/summary`}
                                  edge="end"
                                  size="small"
                                >
                                  <ArrowForwardIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Card>
                    
                        <Dialog
                          fullWidth
                          maxWidth="md"
                          PaperProps={{
                            style: {
                              minHeight: '20vw',
                              maxHeight: '80vw',
                              overflowX:'hidden',
                              overflowY:'auto',
                              boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)'
                            },
                          }}
                         
                          open={CustomerAppointment}
                          onClose={handleCloseCustomerAppointment}
                          aria-labelledby="alert-dialog-slide-title"
                          aria-describedby="alert-dialog-slide-description"
                          BackdropProps={{
                            style: { backgroundColor: 'rgba(0, 0, 0, 0)' ,background:'none'},
                          }}
                        >
                          <DialogTitle id="alert-dialog-title">
                            {t('Randevu')}
                          </DialogTitle>
                          <DialogContent>
                            {LoadingControl
                              ? (
                                <CircularProgress
                                  status="loading"
                                  style={{ marginLeft: '50%' }}
                                />
                              )
                              : ''}
                            <>
                              <Card>
                                <CardContent>
                                  <b>{AtananIs?.ContactName}</b>
                                  <br />
                                  {t('Randevu')}
                                  :
                                  {' '}
                                  <b>
                                    {AtananIs?.AppointmentDate === undefined ? '' : moment(AtananIs?.AppointmentDate).format('DD/MM/YYYY HH:mm')}
                                  </b>
                                  <br />
                                </CardContent>
                              </Card>
                              <br />
                              <ThemeProvider theme={materialTheme}>
                                <MuiPickersUtilsProvider
                                  utils={DateFnsUtils}
                                  locale={localeMap[locale]}
                                >
                                  <KeyboardDateTimePicker
                                    color="primary"
                                    fullWidth
                                    size="small"
                                    ampm={false}
                                    inputVariant="outlined"
                                    id="WarrantyDate"
                                    label={t('lblAppointmentDate')}
                                    invalidDateMessage={t('hatali_tarih')}
                                    format="dd.MM.yyyy HH.mm"
                                    variant="outlined"
                                    value={NewAppointment}
                                    onChange={e => setAppointmentData(e)}
                                    KeyboardButtonProps={{
                                      'aria-label': 'change date'
                                    }}
                                  />
                                </MuiPickersUtilsProvider>
                              </ThemeProvider>
                            </>
                          </DialogContent>
                          <DialogActions>
                          <Grid container spacing={4}>
                          <Grid item xs={6} sm={6} lg={6} align="right">
                            <Button
                              onClick={(event) => handleCloseCustomerAppointment()}
                              color="primary"
                              variant="contained"
                              size="small"
                              endIcon={<CancelIcon />}
                              style={{ backgroundColor: '#B8001F' }}
                            >
                              {t('lblClose')}
                            </Button>
                          </Grid>
                          <Grid item xs={6} sm={6} lg={6}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={(event) => updateAppointmentDate(selectedReceiptNo)}
                              size="small"
                              endIcon={<AlarmIcon />}
                              style={{ backgroundColor: '#508D4E' }}
                            >
                              {t('lblUpdate')}
                            </Button>
                          </Grid>
                          </Grid>
                          </DialogActions>

                        </Dialog>
                      </Card>
                      <Divider className={classes.dividerAtanan} />
                    </div>
                  ))}
                </List>
                :
                (
                  <div>
                    <Divider />
                    <Card>
                      <CardContent className={classes.content}>
                        <Typography variant="h5" gutterBottom>
                          <br />
                          <br />
                          <LocalCafeIcon />
                          <br />
                          <br />
                          {t('undatedAppointment')}
                          <br />
                          <br />
                          <br />
                          <br />
                        </Typography>
                      </CardContent>
                    </Card>
                  </div>
                )
            )
        }
        <FgsArama
          onClose={handleFgsAramaClose}
          ReceiptNo={ReceiptNo}
          open={openFgsArama}
        />
      </Card>

      <Dialog
        open={rejectOpen}
        onClose={() => setRejectOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmRejectTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmRejectDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => handleClickReject(rejectJob)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setRejectOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ConfirmDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => statusUpdate(confirmJob, confirmnewStatus)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* <Dialog
        open={openChooseDate}
        onClose={() => setopenChooseDate(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BaslangiçTarihi"
                  label={t('BaslangicTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={StartDate}
                  onChange={(e) => StartDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BitisTarihi"
                  label={t('BitisTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={EndDate}
                  onChange={(e) => EndDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleRefreshDate(e)} color="primary" autoFocus>
            {t('Ok')}
          </Button>
        </DialogActions>
      </Dialog> */}
        <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Notifications.propTypes = {
  className: PropTypes.string
};

// export default Notifications;


export default connect(
  (state) => ({ loading: state.tasks1.loading }),
  { setTask }
)(Notifications);
